import { errorReporter } from '@/app/error-handling'
import { CommandQueue as BaseCommandQueue, CancelToken } from '@xlearn/async-toolbox'
export { CancelToken } from '@xlearn/async-toolbox'

export type CommandHandler = (cancelToken: CancelToken) => Promise<void>;

export class CommandQueue extends BaseCommandQueue {

  constructor(debugName: string) {
    super(debugName, errorReporter)
  }
}
